import {
  PATH_NAME_APOLLO_PLAYER
} from '@/common/router.const'
import store from '@/store'
import utils from '@/common/util/utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'

let apolloRoute = [
  {
    path: '/apollo/player/:section',
    name: PATH_NAME_APOLLO_PLAYER,
    components: {
      player: () => import(/* webpackChunkName: "play" */'@/views/play/apollo/ApolloPlayerDetail')
    },
    props: true,
    beforeEnter (to, from, next) {
      store.commit('hideNavigationMenu')
      if (from.name !== 'login' && from.name !== 'profile_list') {
        utils.cookies.setItem('referer-url', from.fullPath, null, URL_COOKIE_DOMAIN, '/')
      }
      next()
    }
  }
]

export default apolloRoute
